<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='客户添加'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        :fullscreen='$isMobile'
        max-width='850'
      >
        <template v-slot:content>
           <v-card class="px-5 py-5" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="客户名称" hide-details='auto' outlined :rules="required" v-model="form.name">
                    <template v-slot:append>
                      <v-menu offset-y :close-on-content-click='false'>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn fab x-small color="blue-grey" dark class="mt-n1" :disabled='!form.name' @click="selectRepeat" v-bind="attrs" v-on="on">
                            <v-icon dark>mdi-magnify</v-icon>
                          </v-btn>
                        </template>
                        <v-card class="mx-auto" min-width="200" :loading="loading">
                          <v-card-text v-if="customer === null">
                            客户不存在！
                          </v-card-text>
                          <v-card-text v-else>
                            负责人:
                            <span  v-for="(item, idx) in customer.contactsPersonList" :key="idx">
                              {{item.name}}
                            </span>
                            <br>
                            公海池: {{customer.poolStatus === 1 ? '私海客户' : '公海客户'}}
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <!-- <v-area-cascader placeholder="注册地选择" type='all' @on-change='areaChange' :level="1" :rules="required" v-model="form.areas"></v-area-cascader> -->
                  <area-cascader
                    v-model="form.areas"
                    :data="areaItems"
                    type='all'
                    :level="1"
                    @change='areaChange'
                    v-if="showAreaSelect"
                  >
                  </area-cascader>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="详细地址(注册地)" hide-details='auto' outlined :rules="required" v-model="form.address">
                    <template v-slot:append>
                      <v-btn fab x-small @click="showAddressSelect" color="blue-grey" dark class="mt-n1">
                        <v-icon dark>mdi-map-marker</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <v-user-select :show-user='2' :disabled="$store.state.userInfo.accountType === 3" outlined hide-details='auto' :rules="array" label="负责人选择" v-model='form.contactsPersonList'></v-user-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    :items="customerTypeItems"
                    label="客户类型"
                    v-model="form.typeId"
                    outlined
                    item-text='name'
                    item-value="id"
                    :rules="required"
                    hide-details='auto'
                    @change="customerTypeChange"
                  ></v-select>
                </v-col>
             </v-row>
              <v-card class="my-5" outlined>
                <v-card-title class="size-17">
                  联系人/负责人/对接人(客户方)
                  <v-spacer></v-spacer>
                  <v-btn text dark small  color="primary" @click="addCustomerContactsPerson()">
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text v-if="form.customerContactsPersons.length > 0">
                  <v-row v-for="(item, idx) in form.customerContactsPersons" :key="idx">
                    <v-col cols="12" md="5">
                      <v-text-field label="姓名"  hide-details='auto' outlined :rules="required" v-model="form.customerContactsPersons[idx].name"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field label="手机/固话" hide-details='auto' outlined :rules="required" v-model="form.customerContactsPersons[idx].phoneNumber"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1">
                      <v-btn class="my-2 mt-2" depressed fab small :disabled='form.typeId !== 53 && form.customerContactsPersons.length <= 1' color="primary" @click="form.customerContactsPersons.splice(idx, 1)">
                        <v-icon dark>mdi-minus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card class="my-5" outlined v-if="form.typeId === 53 || form.channelContactsPersons.length > 0">
                <v-card-title class="size-17">
                  联系人/负责人/对接人(渠道方)
                  <v-spacer></v-spacer>
                  <v-btn text dark small color="primary" @click="addChannelContactsPerson()">
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text v-if="form.channelContactsPersons.length > 0">
                  <v-row v-for="(item, idx) in form.channelContactsPersons" :key="idx">
                    <v-col cols="12" md="5">
                      <v-text-field label="姓名"  hide-details='auto' outlined :rules="required" v-model="form.channelContactsPersons[idx].name"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field label="手机号/固话" hide-details='auto' outlined :rules="required" v-model="form.channelContactsPersons[idx].phoneNumber"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1">
                      <v-btn class="my-4 mt-2" depressed fab :disabled='form.typeId === 53 && form.channelContactsPersons.length === 1' small color="primary" @click="form.channelContactsPersons.splice(idx, 1)">
                        <v-icon dark>mdi-minus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field label="其他备注信息" hide-details='auto' outlined  v-model="form.channelContactsPersons[0].remark"></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    :items="customerGradeItems"
                    label="客户分级"
                    v-model="form.gradeId"
                    outlined
                    item-text='name'
                    item-value="id"
                    :rules="required"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    :items="customerTradeItems"
                    label="客户行业"
                    v-model="form.tradeId"
                    outlined
                    item-text='name'
                    item-value="id"
                    :rules="required"
                  ></v-select>
                </v-col>
              </v-row>

            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" class="px-2" :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
    </base-material-dialog>
    <place-search :dialog='placeDialog' @on-dialog-change='placeDialogChange' @on-submit='subPlace'></place-search>
  </v-container>
</template>

<script>
  import { getByPids } from '@/api/system/dictionary.js'
  import { save, repeat } from '@/api/customer/index.js'
  import VUserSelect from '@/components/select/v-user-select.vue'
  import PlaceSearch from '@/components/map/PlaceSearch.vue'
  import Cascader from '@/components/area/Cascader.vue'
  import { pcaa } from 'area-data'

  export default {
    name: 'CustomerAdd',
    components: {
      VUserSelect,
      PlaceSearch
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null,
          name: '',
          screeningId: '',
          personsName: '',
          personsPhone: ''
        })
      }
    },
    data() {
      return {
        aeeas: pcaa,
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => /^[0-99]+.?[0-99]*$/.test(value) || '必须输入数字',
        ],
        array: [
          value => value.length > 0 || '此项为必填项!'
        ],
        customer: {},
        typeItems: [],
        customerStageItems: [],
        customerTypeItems: [],
        customerNatureItems: [],
        customerGradeItems: [],
        customerTradeItems: [],
        customerFromItems: [],
        customerDegreeItems: [],
        area: '',
        areaCode: '',
        placeDialog: false,
        showAreaSelect: false,
        form: {
          id: '',
          areas: [],
          area: '',
          areaCode: '',
          address: '',
          name: '',
          stageId: this.$constants.CustomerState.NEED_ID,
          stageDesc: '',
          screeningId: '',
          contactsPersons: '',
          contactsPersonList: [],
          assistPersons: '',
          assistPersonList: [],
          customerContactsPersons: [
            {
              id: '', name: '', phoneNumber: '', wechatNumber: '', dept: '', type: 1
            }
          ],
          channelContactsPersons: [],
          typeId: '',
          natureId: '',
          gradeId: '',
          tradeId: '',
          fromId: '',
          degreeId: ''
        },
        defForm: {
          id: '',
          areas: [],
          area: '',
          areaCode: '',
          address: '',
          name: '',
          stageId: this.$constants.CustomerState.NEED_ID,
          stageDesc: '',
          screeningId: '',
          contactsPersons: '',
          contactsPersonList: [],
          assistPersons: '',
          assistPersonList: [],
          customerContactsPersons: [
            {
              id: '', name: '', phoneNumber: '', type: 1, remark: ''
            }
          ],
          channelContactsPersons: [
            {
              id: '', name: '', phoneNumber: '', type: 2, remark: ''
            }
          ],
          typeId: '',
          natureId: '',
          gradeId: '',
          tradeId: '',
          fromId: '',
          degreeId: ''
        }
      }
    },
    methods: {
      save () {
        this.form.contactsPersons = JSON.stringify(this.form.contactsPersonList)
        this.form.assistPersons = JSON.stringify(this.form.assistPersonList)
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      syncAddress () {
        this.form.contactsAddress = this.form.area + this.form.address
      },
      builSubForm () {
        this.form.contactsPersons = JSON.stringify(this.form.contactsPersonList)
        this.form.assistPersons = JSON.stringify(this.form.assistPersonList)
      },
      addCustomerContactsPerson () {
        this.form.customerContactsPersons.push(
          {
            id: '', name: '', phoneNumber: '', type: 1
          }
        )
      },
      addChannelContactsPerson () {
        this.form.channelContactsPersons.push(
          {
            id: '', name: '', phoneNumber: '', type: 2
          }
        )
      },
      customerTypeChange (val) {
        if (val === 53 && this.form.channelContactsPersons.length === 0) {
          this.addChannelContactsPerson()
        } else if (this.form.customerContactsPersons.length === 0) {
          this.addCustomerContactsPerson()
        }
      },
      areaChange (selected) {
        this.form.areaCode = []
        this.form.area = []
        const this_ = this
        selected.forEach(area => {
          for (const st in area) {
            this_.form.areaCode.push(st)
            this_.form.area.push(area[st])
          }
        })
        this.form.areaCode = this.form.areaCode.toString()
        this.form.area = this.form.area.toString().replaceAll(',', '/')
      },
      subPlace (area) {
        this.showAreaSelect = false
        this.form.areas = [ area.provinceCode, area.cityCode, area.areaCode ]
        this.form.address = area.simplAddress
        this.placeDialogChange(false)
        setTimeout(() => { this.showAreaSelect = true }, 0);
      },
      showAddressSelect () {
        this.placeDialog = true
      },
      placeDialogChange (val) {
        this.placeDialog = val
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form = JSON.parse(JSON.stringify(this.item.data))
          } else {
            this.form.name = this.item.name
            this.form.screeningId = this.item.screeningId
            this.form.customerContactsPersons[0].name = this.item.personsName
            this.form.customerContactsPersons[0].phoneNumber = this.item.personsPhone
            this.form.contactsPersonList = [
              {
                id: this.$store.state.userInfo.id,
                name: this.$store.state.userInfo.name,
                uid: this.$store.state.userInfo.userId
              }
            ]
          }
          this.showAreaSelect = true
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
          this.$refs.form.resetValidation()
          this.showAreaSelect = false
        }
      },
      selectRepeat () {
        this.loading = true
        repeat(this.form).then(res => {
          if (res.status === 200) {
            this.customer = res.data
          }
          this.loading = false
        })
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.customerStagePid,
              this.$constants.customerTypePid,
              this.$constants.customerNaturePid,
              this.$constants.customerGradesPid,
              this.$constants.customerTradePid,
              this.$constants.customerFromPid,
              this.$constants.customerDegreePid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
            const this_ = this
            res.data.forEach((result) => {
              if (this_.$constants.customerStagePid === result.id) {
                this_.customerStageItems = result.data
              } else if (this_.$constants.customerTypePid === result.id) {
                this_.customerTypeItems = result.data
              } else if (this_.$constants.customerNaturePid === result.id) {
                this_.customerNatureItems = result.data
              } else if (this_.$constants.customerGradesPid === result.id) {
                this_.customerGradeItems = result.data
              } else if (this_.$constants.customerTradePid === result.id) {
                this_.customerTradeItems = result.data
              } else if (this_.$constants.customerFromPid === result.id) {
                this_.customerFromItems = result.data
              } else if (this_.$constants.customerDegreePid === result.id) {
                this_.customerDegreeItems = result.data
              }
           })
          }
        })
      }
    },
    created () {
      this.getTypes()
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null
      },
      areaItems () {
        return require('@/assets/json/area_henan.json')
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
